import React, { Fragment } from 'react';

const Editupload = () => {
  return <Fragment />;
};

export default Editupload;
